// Lightweight debug logger gated by env flag or localStorage
// Enable by setting REACT_APP_DEBUG_TRACE=true or localStorage.setItem('debug', 'true')

const isDebugEnabled = () => {
  // Check environment variable first
  if (String(process.env.REACT_APP_DEBUG_TRACE).toLowerCase() === 'true') {
    return true;
  }
  // Check localStorage (for runtime debugging)
  try {
    return localStorage.getItem('debug') === 'true';
  } catch {
    return false;
  }
};

export const debugEnabled = isDebugEnabled();

export function dlog(...args: any[]) {
  if (!isDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.log(...args);
}

export function pick<T extends Record<string, any>>(obj: T, keys: string[]): Partial<T> {
  const out: Partial<T> = {};
  keys.forEach((k) => {
    const val = (obj as any)?.[k];
    if (val !== undefined) (out as any)[k] = val;
  });
  return out;
}

export function safeJson(value: any): any {
  try {
    return JSON.parse(JSON.stringify(value));
  } catch {
    return undefined;
  }
}


